import React from "react";
import tw from "tailwind-styled-components";
import { Formik, Field, Form } from "formik";
import Loading from "../Loading";
import {
  InputGroup,
  FieldWrapper,
  Label,
  SubmitBtn,
  CombineInputGroup,
} from "../Styles/InputStyles";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import moment from "moment";
// import Select from "react-select";
import Model from "../Model";
import CustomPhoneInput from "../CountryCode";
const EditTransportationModel = ({
  editAddUser,
  editEntryLoading,
  setEditUser,
  selectedData,
}) => {

  const genderOption = [
    { value: "1", label: "Male" },
    { value: "2", label: "Female" },
  ];
  const buyerType = [
    { value: "1", label: "Consumer" },
    { value: "2", label: "Trade" },
  ];
  const InitialValues = {
    balance: selectedData?.balance,
    cropType: selectedData?.cropType,
    cropName: selectedData?.cropName,
    destination: selectedData?.destination,
    buyerName: selectedData?.buyerName,
    buyerType: selectedData?.buyerType,
    phone: selectedData?.phone,
    quantitySold: selectedData?.quantitySold,
    gender: selectedData?.gender,
    id: selectedData?.id,

    receivingDate: moment(selectedData?.receivingDate).format("YYYY-MM-DD"),
    quantityProductAvailable: selectedData?.quantityProductAvailable,
    quantityProductRecived: selectedData?.quantityProductRecived,
  };




  const SubmitHandler = (values) => editAddUser(values);


  return (
    <Model width={`w-11/12 max-w-3xl`} setOpenModel={setEditUser}>
      <Title>Edit Stock</Title>

      {editEntryLoading && <Loading />}

      {!editEntryLoading && (
        <Formik initialValues={InitialValues} onSubmit={SubmitHandler}>
          <Form>
            <Wrapper>
              <CombineInputGroup>
                <InputGroup>
                  <Label htmlFor="cropType" >Crop Name</Label>
                  <FieldWrapper>
                    <Field name="cropName" id="cropType" type="text" autoComplete="off" required disabled />
                  </FieldWrapper>
                </InputGroup>
                <InputGroup>
                  <Label htmlFor="receivingDate">Receiving Date</Label>
                  <FieldWrapper>
                    <Field
                      type="date"
                      name="receivingDate"
                      id="receivingDate"
                      autoComplete="off"
                      className="truncate"
                      required
                    />
                  </FieldWrapper>
                </InputGroup>
              </CombineInputGroup>
              <CombineInputGroup>
                <InputGroup>
                  <Label htmlFor="quantityProductRecived">Product Received Quantity (kg)</Label>
                  <FieldWrapper>
                    <Field
                      type="number"
                      name="quantityProductRecived"
                      id="quantityProductRecived"
                      autoComplete="off"
                      className="truncate"
                      required
                    />
                  </FieldWrapper>
                </InputGroup>

                <InputGroup>
                  <Label htmlFor="quantityProductAvailable">Product Available Quantity (kg)</Label>
                  <FieldWrapper>
                    <Field
                      type="number"
                      name="quantityProductAvailable"
                      id="quantityProductAvailable"
                      autoComplete="off"
                      className="truncate"
                      required
                    />
                  </FieldWrapper>
                </InputGroup>
                <InputGroup>
                  <Label htmlFor="quantitySold">Quantity Sold (kg)</Label>
                  <FieldWrapper>
                    <Field
                      type="number"
                      name="quantitySold"
                      id="quantitySold"
                      autoComplete="off"
                      className="truncate"
                      required
                    />
                  </FieldWrapper>
                </InputGroup>
              </CombineInputGroup>

              <CombineInputGroup>
                <InputGroup>
                  <Label htmlFor="buyerName">Buyer Name</Label>
                  <FieldWrapper>
                    <Field
                      type="text"
                      name="buyerName"
                      id="buyerName"
                      autoComplete="off"
                      className="truncate"
                      required
                    />
                  </FieldWrapper>
                </InputGroup>


                <InputGroup>
                  <Label htmlFor="gender">Gender</Label>
                  <FieldWrapper $select={true}>
                    <Field required name="gender" id="gender" autoComplete="off">
                      {(props) => (
                        <Select
                          className="w-full h-full pl-2"
                          {...props.field}
                        >
                          <MenuItem value="1">Male</MenuItem>
                          <MenuItem value="2">Female</MenuItem>

                        </Select>
                      )}
                    </Field>
                  </FieldWrapper>
                </InputGroup>
                <InputGroup>
                  <Label htmlFor="phone">Phone Number</Label>
                  <Field
                    name="phone"
                    render={({ field, form }) => (
                      <CustomPhoneInput field={field} form={form} />
                    )}
                  />
                </InputGroup>
              </CombineInputGroup>
              <CombineInputGroup>


                <InputGroup>
                  <Label htmlFor="buyerType">Type of Buyer</Label>
                  <FieldWrapper $select={true}>
                    <Field required name="buyerType" id="buyerType" autoComplete="off">
                      {(props) => (
                        <Select
                          className="w-full h-full pl-2"
                          {...props.field}
                        >
                          <MenuItem value="1">Consumer</MenuItem>
                          <MenuItem value="2">Trade</MenuItem>

                        </Select>
                      )}
                    </Field>
                  </FieldWrapper>
                </InputGroup>
                <InputGroup>
                  <Label htmlFor="balance">Balance Quantity (kg)</Label>
                  <FieldWrapper>
                    <Field
                      type="number"
                      name="balance"
                      id="balance"
                      autoComplete="off"
                      className="truncate"
                      required
                    />
                  </FieldWrapper>
                </InputGroup>

                <InputGroup>
                  <Label htmlFor="destination">Destination</Label>
                  <FieldWrapper>
                    <Field
                      type="text"
                      name="destination"
                      id="destination"
                      autoComplete="off"
                      className="truncate"
                      required
                    />
                  </FieldWrapper>
                </InputGroup>
              </CombineInputGroup>

            </Wrapper>
            <BtnWrapper>
              <SubmitBtn type="submit">Update</SubmitBtn>
            </BtnWrapper>
          </Form>
        </Formik>
      )}
    </Model>
  );
};

const Wrapper = tw.div`
grid gap-6 my-6 px-1 `;

const Title = tw.h1`text-lg md:text-xl font-medium text-center text-gray-800`;
const BtnWrapper = tw.div` w-full flex items-center justify-center space-x-10 mt-8`;

export default EditTransportationModel;
